// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type ToolConfigListe } from "../../api";
import { useGetToolConfigsForAufgabe as useGetter } from "../hooks";
import { type QueryKey, useQuery, type UseQueryOptions } from "react-query";

export function useToolConfigsForAufgabeQueryKey(
  aufgabeId: string,
  toolId: string
): QueryKey {
  return ["api", "v1", "aufgaben", aufgabeId, "tools", toolId, "configs"];
}

export function useToolConfigsForAufgabe(
  aufgabeId: string,
  toolId: string,
  options: Omit<
    UseQueryOptions<ToolConfigListe, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): ToolConfigListe {
  const getter = useGetter();
  return useQuery(
    useToolConfigsForAufgabeQueryKey(aufgabeId, toolId),
    () => getter(aufgabeId, toolId),
    options
  ).data!;
}
